import { useState } from 'react';

import { cn } from '../../../utils/tailwind.utils';
import { TextIconColor } from '../constants';
import { Icon, Icons } from '../Icon';

interface ExpandProps {
  children: React.ReactNode;
  trigger: React.ReactNode;
  chevronIconColor?: TextIconColor;
  disabled?: boolean;
  startExpanded?: boolean;
}

const Expand: React.FC<ExpandProps> = ({
  children,
  trigger,
  startExpanded = false,
  chevronIconColor = TextIconColor.PRIMARY,
  disabled = false
}) => {
  const [isExpanded, setIsExpanded] = useState(startExpanded);

  return (
    <div className="flex w-full flex-col gap-2" data-testid="expand-container">
      <div
        className={cn(
          'flex items-center justify-start gap-2',
          !disabled && 'cursor-pointer'
        )}
        data-testid="expand-trigger"
        onClick={() => !disabled && setIsExpanded(!isExpanded)}
      >
        {!disabled && (
          <Icons
            color={chevronIconColor}
            icon={isExpanded ? Icon.CHEVRON_DOWN : Icon.CHEVRON_RIGHT}
          />
        )}
        {trigger}
      </div>
      {!disabled && isExpanded && children}
    </div>
  );
};

export default Expand;
